import { Chip } from '@mui/material';
import withStyles from '@mui/styles/withStyles';
import Colors from '../../../../layout/theme/utils/colors';

const styles = () => ({
  root: {
    backgroundColor: Colors.font_gray,
    borderRadius: '3px',
  },
  colorPrimary: {
    color: Colors.white,
  },
  iconSmall: {
    height: '14px',
    width: '13px',
  },
  labelSmall: {
    fontSize: '12px',
    fontWeight: 700,
    'text-transform': 'uppercase',
  },
});

export const HoverStyleChip = withStyles(styles)(Chip);
